import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { Certify } from "../../Models/Course";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { CourseCertificate, PathCertificate } from "../../Models/Certificates";

export class PrintingListVM extends InterActive{
    private courses:CourseCertificate[] = []
    private pathes:PathCertificate[] = []
    private coursesSearch:string = ''
    private pathsSearch:string= ''
    private coursesStop:boolean = false
    private pathsStop:boolean = false
    private coursesLoading:boolean = false
    private pathsLoading:boolean = false
    private refreshes:number = 0

    public get Courses():CourseCertificate[]{ return this.courses }
    public get Pathes():PathCertificate[]{ return this.pathes }
    public get Refreshes():number{ return this.refreshes }

    public set CoursesSearch(value:string){ this.coursesSearch = value; this.searchCourses(); this.update() }
    public set PathsSearch(value:string){ this.pathsSearch = value; this.searchPaths(); this.update() }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.printingList()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.courses = response.data.data.courses
                                this.pathes = response.data.data.pathes
                                this.update()
                            }else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }

    public async searchCourses(){
        try{
            const response = await ApiRequest.getMoreCoursesPrintingList({id:'' , search:this.coursesSearch})
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.coursesStop = false
                        this.courses = [...response.data.data]
                        this.update()
                    }else  Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
    }
    public async addCourses(){
        if(!this.coursesLoading){
            this.coursesLoading = true
            if(!this.coursesStop){
                try{
                    const id = this.courses.length>0?this.courses[this.courses.length-1].id:''
                    const response = await ApiRequest.getMoreCoursesPrintingList({id:id , search:this.coursesSearch})
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.length==0){
                                    this.coursesStop = true
                                    this.update()
                                }else {
                                    this.courses = [...this.courses,...response.data.data]
                                    this.update()
                                }
    
                            }else  Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
            this.coursesLoading =false
        }
        
    }

    public async searchPaths(){
        try{
            const response = await ApiRequest.getMorePathsPrintingList({id:'' , search:this.pathsSearch})
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.pathsStop = false
                        this.pathes = [...response.data.data]
                        this.update()
                    }else  Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
    }
    public async addPaths(){
        if(!this.pathsLoading){
            this.pathsLoading = true
            if(!this.pathsStop){
                try{
                    const id = this.pathes.length>0?this.pathes[this.pathes.length-1].id:''
                    const response = await ApiRequest.getMorePathsPrintingList({id:id , search:this.pathsSearch})
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.length==0){
                                    this.pathsStop = true
                                    this.update()
                                }else {
                                    this.pathes = [...this.pathes,...response.data.data]
                                    this.update()
                                }
    
                            }else  Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
            this.pathsLoading =false
        }
        
    }

    public certify(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.certify()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status) {
                                this.refreshes++
                                this.update()
                            }
                            else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }

    public async confirmCourse(id:string ,code:string , name:string  ,specialization:string ,trainee_id:string , trainee_name:string, trainee_english_name:string ,start :string , end:string , hours:string, institution:string , notes:string){
        try{
            const response = await ApiRequest.confirmPrintingCourse(id , name ,specialization,trainee_id, trainee_name , trainee_english_name , start  , end, hours, institution ,code , notes)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status) return true
                    else  Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                }else  Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
        return false
    }
    public async confirmPath(id:string ,code:string , path:string ,trainee_id:string , trainee_name:string, trainee_english_name:string , start :string , end:string , hours:string, institution:string , notes:string , verification:string){
        try{
            const response = await ApiRequest.confirmPrintingPath(id , path,trainee_id, trainee_name, trainee_english_name, start  , end, hours, institution ,code , notes, verification)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status) return true
                    else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
        return false
    }
}